<script>
import FormComponent from './Form/component.vue';

export default {
  components: {
    FormComponent,
  },
  props: {
    module: {
      type: Object,
    },
    link: String,
  },
  data: () => ({
    total: 0,
    items: [],
    name: 'tourStatistic',
    page: false,
  }),
  methods: {
    handlerSubmit() {
      this.module.submit()
        .finally(() => {
          this.init = true;
        });
    },
    currentChange(data) {
     this.module.currentChange(data);
    },
    setSorting(data) {
      this.module.setSorting(data);
    },
    setPerPage(data) {
      //this.module.setPertPage(data);
    },
    exportToXlS() {
      window.location.href = this.module.url;
    },
    clickRow(item) {
      window.location.href = `/tourclient/admin/orders/info.html?code=${item.AgreementCode}`;
    }
  },
  computed: {
    columns: function () {
      return this.module.columns;
    }
  },
  watch: {
    'module.dateUpdate'() {
      this.total = this.module.total;
      this.items = this.module.items.map(i => ({
        ...i,
      }));
    },

  },
};
</script>
<template>
  <div class="app-template-page__body">
    <div class="tour-list-form">
      <FormComponent
        :module="module.form"
        @submit="handlerSubmit"
      />
    </div>
      <TableFull
        class="client-list-table"
        :items="items"
        :columns="columns"
        :loading="module.loading"
        :page="page"
        :total-count="total"
        :name='name'
        :button="120"
        style="height: calc(100vh - 90px)"
        panel
        :showAll="false"
        @currentChange ="currentChange"
        @setSorting ="setSorting"
        @setPerPage ="setPerPage"
        @clickRow="clickRow"
        @dblclick-row="clickRow"
      >
        <span slot="panel">
        <Button  v-if="module.showExport" class="btn btn-primary" style="background-color: #6db234; border-color: #6db234; font-size: 14px; height: 32px; padding: 0 15px;  line-height: 30px;  margin-top: 3px;"
                @click="exportToXlS">
         XLS
        </Button>
    </span>
      </TableFull>
  </div>
</template>
<style lang="scss">
.list-card__pagination {
  background: #f3f5f4;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border: 1px solid #d5dfe7;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;

  .list__btns {
    padding: 5px 0px;
    margin-left: 7px;
  }
  .el-button--default{
    color: #606266;
    background-color: transparent;
    border-color: transparent;
    border-color:#dcdfe6 ;
  }
  .el-button--primary{
    color: #fff;
    background-color: #6db234;
    border-color: #6db234;
  }
  .el-button:hover {
    color: #6db234;
    border-color: #d3e8c2;
    background-color: #f0f7eb;
  }
  .el-button--primary:hover {
    background: #8ac15d;
    border-color: #8ac15d;
    color: #fff;
  }
}
  .p-t-c-l {
    &__flex {
      display: flex;
      .el-button--primary {
        color: #FFFFFF;
        background-color: #6db234;
        border-color: #6db234;
      }
    }

    &__filter {
      width: 300px;
      flex-shrink: 0;
      margin: 0 24px 0 0;
    }

    &__items {
      flex: 1;
    }

    &__error {
      text-align: center;
      padding: 36px;
    }
  }

  @media (max-width: 1000px) {
    .p-t-c-l__filter {
      display: none;
    }
  }
</style>
